/*
 * Local Import
 */

// Helpers
import { getBreadcrumb } from 'src/modules/jsonLD';

/*
 * SEO
 */
const seo = {
  title: '',
  description: '',
  og: {
    title: '',
    description: '',
    image: '',
  },
  color: 'default',
};

/*
 * JSON-LD
 */
const jsonLD = [
  // Breadcrumb list
  getBreadcrumb([
    {
      name: 'Le programme',
      // item: getPathname('program'),
    },
  ]),
];

/*
 * Export
 */
export default { seo, jsonLD };
